export default __webpack_public_path__ + "static/media/poster1.f91e8f6d.png";